/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
// This import is weird but needed to get the Adaptive Card Templating SDK
// DO NOT also attempt to upgrade adaptivecards-templating to v2 or later.
// See this issue: https://github.com/microsoft/AdaptiveCards/issues/9078
import * as ACData from "adaptivecards-templating/dist/adaptivecards-templating.min.js";
import { AdaptiveCard } from "./AdaptiveCard";

export type AdaptiveCardsSchema = Record<string, unknown>;
export const adaptiveCardsPropsPrefix = 'adaptiveCards';

export type AdaptiveCardsTemplateProps = {
    schema: AdaptiveCardsSchema;
    data: Record<string, unknown>;
};

/**
 * Renders an Adaptive Card based on a provided schema and data.
 * @param props - The properties for the Adaptive Cards Template component, including the schema and data.
 * @returns A rendered Adaptive Card element or null if parsing fails.
 */
export const AdaptiveCardsTemplate: React.FC<AdaptiveCardsTemplateProps> = ({ schema, data }) => {
    const cardSource = React.useMemo(() => {
        try {
            const template = new ACData.Template(schema);
            return template.expand({ $root: data });
        } catch (error) {
            console.error("Failed to expand adaptive card template:", error);
            return schema;
        }
    }, [schema, data]);

    return <AdaptiveCard source={cardSource} />;
};
